<template>
  <AppCard class="full-width">
    <div
      v-if="$slots.top"
      class="top q-py-lg q-px-xl"
    >
      <slot name="top"/>
    </div>
    <div
      :class="{'q-pt-lg-xl q-pt-md-lg': !$slots.top}"
      class="column no-wrap justify-between content-center full-height full-width q-pb-lg-xl q-pb-md-lg"
    >
      <div v-if="title">
        <div class="title flex justify-center text-24-700 text-center q-px-md-lg q-px-lg-xl">
          {{ title }}
        </div>
      </div>
      <div class="full-width q-px-md-lg q-px-lg-xl">
        <div class="max-width-450 full-width">
          <slot/>
        </div>
      </div>
    </div>
  </AppCard>
</template>

<script>
import AppCard from 'common/components/AppCard';

export default {
  name: 'AuthWrapper',
  components: { AppCard },
  props: {
    title: {
      type: String,
      default: undefined,
    },
    logo: {
      type: String,
      default: undefined,
    },
    owner: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
